import { render, staticRenderFns } from "./popeningbalance.vue?vue&type=template&id=1567177f&scoped=true&"
import script from "./popeningbalance.vue?vue&type=script&lang=js&"
export * from "./popeningbalance.vue?vue&type=script&lang=js&"
import style0 from "./popeningbalance.vue?vue&type=style&index=0&id=1567177f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1567177f",
  null
  
)

export default component.exports